import React from "react";
import {
  Button,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ButtonGroup,
  makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux"
import { eliminarHotelPaqueteTerrrestre, obtenerHotelelesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck";
import Swal from "sweetalert2"
import { ToastMessage } from "../../../global/ToastMessage"
import { DialogMessage } from "../../../global/DialogMessage"
import LabelServicios from "./LabelServicios"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck";
const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  container: {
    maxHeight: 300,
  },
})
const TablaRegistro = () => {
  const { paqueteSelect, listaHoteletesTerrestre } = useSelector(store => store.proveedorTerrestre)
  const dispatch = useDispatch();
  const classes = useStyles();

  const onDelete = (row) => {
    DialogMessage.fire({
      title: '¿Estas seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(onLoadAnction({message: ""}))
        dispatch(eliminarHotelPaqueteTerrrestre({ idPaqueteTerrestreHotel: row?.IdPaqueteProveedorTerrestreHotel })).then(Response => {
          dispatch(obtenerHotelelesPaqueteTerrestre({ idPaqueteTerrestre: paqueteSelect?.IdPaqueteProveedorTerrestre }))
          dispatch(offLoadAction())
          ToastMessage.fire(
            'Elimminado',
            'El vuelo ha sido eliminado.',
            'success'
          )
        })
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        ToastMessage.fire(
          'Cancelado',
          'No se ha realizado ningun cambio',
          'info'
        )
      }
    })
  }
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell align="center">Origen</TableCell>
            <TableCell align="center">Nombre</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {listaHoteletesTerrestre.map((row, index) => (
            <TableRow key={index + 1}>
              <TableCell align="center">{`${row.Hotel.Origen.Nombre}`}</TableCell>
              <TableCell align="center">{`${row.Hotel.Descripcion}`}</TableCell>
              <TableCell align="center">
                <ButtonGroup
                  color="primary"
                  size="small"
                  aria-label="small outlined  button group"
                >
                  <Button onClick={() => onDelete(row)} >Eliminar</Button>
                </ButtonGroup>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default TablaRegistro;
